import { render, staticRenderFns } from "./ui-textarea.vue?vue&type=template&id=34d8aa36&scoped=true"
import script from "./ui-textarea.vue?vue&type=script&lang=js"
export * from "./ui-textarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d8aa36",
  null
  
)

export default component.exports